import { Alignment } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import {
    DialogProps, Image, Label, Layout, Overlay, OverlayProps, Panel, ScreenStack, SlideoutDecorator,
    SlideoutDecoratorProps, Snackbar, SnackbarOptions, Toast, ToastOptions
} from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutDemoScreenFlowSampleButtons } from "./autogen/AutogenLayoutDemoScreenFlowSampleButtons";

let dialogCount = 0;
let snackbarCount = 0;
let toastCount = 0;
let slideoutCount = 0;

export class DemoScreenFlowSampleButtons extends AutogenLayoutDemoScreenFlowSampleButtons {
    showDialog(props: Partial<DialogProps>) {
        const dialogProps = { ...this.buildDialogProps(), ...props };
        const layout = Layout.getLayout("component-demo/dialogs/DemoScreenFlowSampleButtons");
        CommonDialogs.showDialog(layout, dialogProps);
    }

    private buildDialogProps(): Partial<DialogProps> {
        return {
            title: "Dialog #" + ++dialogCount,
            modal: this.switchDialogModal.checked,
            movable: this.switchDialogMovable.checked,
            resizable: this.switchDialogResizable.checked
        };
    }

    showOverlay() {
        const layoutProps = { backgroundColor: "background", padding: 18, fillHeight: false };
        const layout = Layout.getLayout("component-demo/dialogs/DemoScreenFlowSampleButtons", layoutProps);
        const overlayProps: Partial<OverlayProps> = {
            centered: true,
            greyedBackground: true
        };
        layout.addLayoutLoadListener(() => Overlay.showInOverlay(layout, overlayProps));
    }

    showBasicSnackbar() {
        const options = this.buildSnackbarOptions();
        Snackbar.showSnackbar("This is snackbar #" + ++snackbarCount, options);
    }

    showWarningSnackbar() {
        const options = this.buildSnackbarOptions();
        Snackbar.showWarningSnackbar("This is snackbar #" + ++snackbarCount, options);
    }

    showDownloadSnackbar() {
        const options = this.buildSnackbarOptions();
        Snackbar.showDownloadSnackbar("Download Snackbar", "This is snackbar #" + ++snackbarCount, options);
    }

    private buildSnackbarOptions(): SnackbarOptions {
        const result: SnackbarOptions = { persist: this.switchSnackbarPersist.checked };
        if (this.switchSnackbarTarget.checked === false)
            result.targetPanel = ScreenStack.getPreviousSnackbarTarget();
        return result;
    }

    showSuccessToast() {
        const options = this.buildToastOptions();
        const message = "This is message #" + ++toastCount + " saying that all is well";
        Toast.showSuccessToast("This Is a Title", message, ImageName.magnifyingGlass, options);
    }

    showCustomToast() {
        const p = new Panel({ backgroundColor: "success" });
        p.add(new Image({ color: "#fff", name: ImageName.magnifyingGlass, height: 22, width: 22, rowBreak: false }));
        p.add(new Label({ color: "#fff", text: "This is a custom toast built in code." }));
        const options = this.buildToastOptions();
        Toast.showToast(p, null, options);
    }

    private buildToastOptions(): ToastOptions {
        const result: ToastOptions = { persist: this.switchToastPersist.checked };
        if (this.switchToastTarget.checked === false)
            result.targetPanel = ScreenStack.getPreviousToastTarget();
        return result;
    }

    showSlideoutTop() {
        this.showSlideout(Alignment.TOP);
    }

    showSlideoutRight() {
        this.showSlideout(Alignment.RIGHT);
    }

    showSlideoutBottom() {
        this.showSlideout(Alignment.BOTTOM);
    }

    showSlideoutLeft() {
        this.showSlideout(Alignment.LEFT);
    }

    private showSlideout(direction: Alignment) {
        const layout = Layout.getLayout("component-demo/dialogs/DemoScreenFlowSampleButtons", { padding: 16 });
        const sodProps: Partial<SlideoutDecoratorProps> = {
            layout,
            title: "Slideout #" + ++slideoutCount,
            transitionOptions: { direction },
            width: window.innerWidth * 0.65
        };
        if (direction === Alignment.LEFT || direction === Alignment.RIGHT)
            sodProps.fillVerticalSpace = true;
        else
            sodProps.fillHorizontalSpace = true;
        new SlideoutDecorator(sodProps);
    }
}
